<template>
  <el-form :model="addForm" ref="addForm" :label-width="isEdit ? '110px' : '200px'" class="formCont">
    <el-form-item
      label="应用类型"
      prop="industry"
      :rules="{
        required: true,
        message: '应用类型不能为空',
        trigger: 'blur'
      }"
      v-if="!isEdit"
    >
      <el-select v-model="addForm.industry" placeholder="请选择" :disabled="disabled" size="small">
        <el-option v-for="item in applicationOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="应用类型" v-else>{{ industryArr[addForm.industry] }}</el-form-item>
    <el-form-item label="应用图标">
      <img v-if="addForm.iconPath" :src="addForm.iconPath" class="icon-img" />
      <el-upload
        class="avatar-uploader"
        :action="uploadUrl"
        :show-file-list="false"
        :on-success="handleSuccess"
        :with-credentials="true"
        :before-upload="beforeUpload"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <span class="tips" v-if="!isEdit">可不传，系统会默认选择一张icon</span>
    </el-form-item>
    <el-form-item
      label="应用名称"
      prop="gameName"
      :rules="{
        required: true,
        message: '应用名称不能为空',
        trigger: 'blur'
      }"
    >
      <el-input v-model="addForm.gameName" size="small" maxlength="40"></el-input>
      <span class="tips" v-if="!isEdit">系统会按照该名称代表此项目</span>
    </el-form-item>
    <el-form-item
      label="APP Name"
      prop="appName"
      :rules="{
        required: true,
        message: 'App Name不能为空',
        trigger: 'blur'
      }"
      v-if="addForm.accessType === 2"
    >
      <el-input v-model="addForm.appName" size="small" maxlength="50"></el-input>
      <span class="tips" v-if="!isEdit">仅支持英文字母或下划线，一旦创建不可修改；例如：com.xxxx</span>
    </el-form-item>
    <el-form-item
      label="应用模式"
      v-if="!isEdit"
      prop="accessType"
      :rules="{
        required: true,
        message: '应用模式不能为空',
        trigger: 'blur'
      }"
    >
      <el-select v-model="addForm.accessType" :disabled="disabled" placeholder="请选择" size="small">
        <el-option v-for="item in accessTypeOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select>
      <span class="tips" v-if="addForm.accessType && !isEdit">{{
        addForm.accessType === 1 ? '聚合渠道追踪，包含移动追踪同事支持系统生产各渠道' : '移动追踪，仅提供投放数据追踪'
      }}</span>
    </el-form-item>
    <el-form-item label="应用模式" v-else>{{ addForm.accessType === 1 ? '聚合追踪' : '移动追踪' }}</el-form-item>
    <el-form-item
      label="回调地址"
      prop="notifyUrl"
      :rules="{
        required: true,
        message: '回调地址不能为空',
        trigger: 'blur'
      }"
      v-if="isShow"
    >
      <el-input v-model="addForm.notifyUrl" size="small" maxlength="256"></el-input>
      <span class="tips" v-if="!isEdit">游戏发货的回调地址</span>
    </el-form-item>
    <el-form-item
      label="支付比例"
      prop="gameScale"
      :rules="{
        required: true,
        message: '支付比例不能为空',
        trigger: 'blur'
      }"
      v-if="isShow"
    >
      <el-input type="number" @input.native="changeNum" v-model="addForm.gameScale" size="small" maxlength="4"></el-input>
      <span class="tips" v-if="!isEdit">填写游戏货币与人民币的换算比例，例如1:10钻石，则填10</span>
    </el-form-item>
    <div v-if="isShow">
      <el-form-item v-for="(item, index) in replaceResourceTemplates" :label="'配置路径' + (index + 1)" :key="index">
        <el-input v-model="item.resourceUrl" size="small"></el-input>
        &nbsp;&nbsp; <el-button @click.prevent="removeResource(item)" size="small">删除</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="addResource" size="small">添加配置路径</el-button>
      </el-form-item>
    </div>
    <el-form-item label="系统类型">
      <el-radio-group v-model="addForm.platform">
        <el-radio :label="1">安卓</el-radio>
        <el-radio :label="2">IOS</el-radio>
      </el-radio-group>
    </el-form-item>
    <div class="applicationRequest" v-if="isEdit">
      <p class="row-divider">
        <span>应用参数</span>
        <el-button type="text" v-clipboard:copy="copyParams" v-clipboard:success="onCopy" v-clipboard:error="onError">复制参数</el-button>
      </p>
      <div v-if="addForm.accessType === 1">
        <el-form-item label="ID">
          <span>{{ addForm.gameId }}</span>
        </el-form-item>
        <el-form-item label="KEY">
          <span>{{ addForm.gameKey }}</span>
        </el-form-item>
        <el-form-item label="SECRET">
          <span>{{ addForm.gameSecret }}</span>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="聚合应用ID">
          <span>{{ addForm.gameId }}</span>
        </el-form-item>
        <el-form-item label="KEY">
          <span>{{ addForm.gameKey }}</span>
        </el-form-item>
        <el-form-item label="SECRET">
          <span>{{ addForm.gameSecret }}</span>
        </el-form-item>
        <el-form-item label="渠道ID">
          <span>{{ addForm.channelId }}</span>
        </el-form-item>
        <el-form-item label="追踪应用ID">
          <span>{{ addForm.devGameId }}</span>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>
<script>
import { HOST_API } from '@/api/config'
export default {
  name: 'addForm',
  props: {
    isEdit: {
      type: Boolean,
      required: true
    },
    addApplicationForm: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      addForm: {},
      industryArr: {
        1: '游戏',
        2: '电商',
        3: '社交',
        4: '工具'
      },
      applicationOptions: [
        {
          value: 1,
          label: '游戏'
        },
        {
          value: 2,
          label: '电商'
        },
        {
          value: 3,
          label: '社交'
        },
        {
          value: 4,
          label: '工具'
        }
      ],
      accessTypeOptions: [
        {
          value: 1,
          label: '聚合追踪'
        },
        {
          value: 2,
          label: '移动追踪'
        }
      ],
      uploadUrl: HOST_API + '/api/ptom/aggregation/uploadAppImage',
      replaceResourceTemplates: [
        {
          resourceUrl: ''
        }
      ],
      pageName: '',
      disabled: false,
      copyParams: ''
    }
  },
  watch: {
    addApplicationForm() {
      this.queryInfo()
    }
  },
  computed: {
    isShow() {
      return (
        (this.addForm.accessType === 1 && this.addForm.industry === 1 && this.pageName === 'comprehensive') ||
        (this.addForm.accessType === 1 && this.addForm.industry === 1 && this.isEdit)
      )
    }
  },
  mounted() {
    const { gameId, gameKey, gameSecret, channelId, devGameId } = this.addForm
    if (this.addForm.accessType === 1) {
      this.copyParams = 'ID:' + gameId + ' Key:' + gameKey + ' secret:' + gameSecret
    } else {
      this.copyParams =
        '聚合应用ID:' + gameId + ' Key:' + gameKey + ' secret:' + gameSecret + ' 渠道ID:' + channelId + ' 追踪应用ID:' + devGameId
    }
  },
  created() {
    this.queryInfo()
  },
  methods: {
    queryInfo() {
      const { name, addItem } = this.$route.query
      this.pageName = name
      this.addForm = JSON.parse(JSON.stringify(this.addApplicationForm))
      if (name === 'polymerization' && addItem) {
        this.addForm.accessType = 1
        this.addForm.industry = JSON.parse(addItem).industry
        this.disabled = true
      } else {
        this.disabled = false
      }
      if (this.isEdit) {
        this.replaceResourceTemplates = this.addForm.replaceResourceTemplateList
      }
      if (this.addForm.replaceResourceTemplates && this.addForm.replaceResourceTemplates.length) {
        this.replaceResourceTemplates = this.addForm.replaceResourceTemplates
      }
    },
    handleSuccess(res, file) {
      if (res.code !== 200) {
        this.$message.error(res.msg)
      }
      this.addForm.iconPath = res.data
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png'
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isJPG) {
        this.$message.error('上传文件只能是 JPG/png 格式!')
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      }
      return isJPG && isLt10M
    },
    removeResource(item) {
      var index = this.replaceResourceTemplates.indexOf(item)
      if (index !== -1) {
        this.replaceResourceTemplates.splice(index, 1)
      }
    },
    addResource() {
      if (this.isEdit) {
        this.replaceResourceTemplates.push({
          id: 0,
          resourceUrl: ''
        })
      } else {
        this.replaceResourceTemplates.push({
          resourceUrl: ''
        })
      }
    },
    changeNum() {
      if (this.addForm.gameScale.length > 4) {
        this.addForm.gameScale = this.addForm.gameScale.slice(0, 4)
      }
    },
    getResource() {
      const newResource = []
      if (this.isEdit) {
        this.replaceResourceTemplates.forEach((item) => {
          newResource.push({
            id: item.id,
            resourceUrl: item.resourceUrl
          })
        })
      } else {
        this.replaceResourceTemplates.forEach((item) => {
          if (!item.resourceUrl) {
            return false
          } else {
            newResource.push(item.resourceUrl)
          }
        })
      }
      return newResource
    },
    onCopy() {
      this.$Message.success('复制成功！')
    },
    onError() {
      this.$Message.warning('剪切板禁止访问')
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.avatar-uploader) {
  display: inline-block;
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .el-upload:hover {
    border-color: #409eff;
  }
}
:deep(.avatar-uploader + .tips) {
  display: inline-block;
  margin-left: 10px;
  line-height: 107px;
  vertical-align: top;
}
:deep(.avatar-uploader-icon) {
  font-size: 28px;
  color: #8c939d;
  width: 107px;
  height: 107px;
  line-height: 107px;
  text-align: center;
}
:deep(.avatar) {
  width: 107px;
  height: 107px;
  display: block;
}
.icon-img {
  display: inline-block;
  width: 107px;
  height: 107px;
  margin-right: 8px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  vertical-align: top;
}
.tips {
  display: block;
  line-height: 24px;
  font-size: 12px;
  color: #606266;
  &::before {
    content: '*';
    display: inline-block;
    margin-right: 5px;
    // color: #f00;
    font-size: 14px;
  }
}
:deep(.el-input) {
  width: 200px;
}
.applicationRequest {
  p.row-divider {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    align-items: center;
    padding-left: 20px;
    line-height: 20px;
    background: #eee;
  }
  .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
